import { useContext } from 'react';
import { StylesContext, createTokenFn } from '@rexlabs/element-styles';
export default function useToken() {
  var t = useContext(StylesContext);
  return createTokenFn((t === null || t === void 0 ? void 0 : t.tokens) || {});
}